import { gql } from 'graphql-tag';

export const GET_CATEGORIES = gql`
  query GetBlogPostsByCategoryOrTag($path: String!, $categoryId: String!, $authorId: String!, $pageSize: Int!, $after: String) {
    search(
      first: $pageSize
      after: $after
      where: {
        AND: [
          {
            name: "_path"
            value: $path
            operator: CONTAINS
          },
          {
            OR: [
              {
                name: "Categories"
                value: $categoryId
                operator: CONTAINS
              },
              {
                name: "Tags"
                value: $categoryId
                operator: CONTAINS
              },
              {
                name: "Author"
                value: $authorId
                operator: CONTAINS
              }
            ]
          }
        ]
      }
      orderBy: { name: "Published Date", direction: DESC }
    ) {
      total
      pageInfo {
        hasNext
        endCursor
      }
      results {
        id
        path
        TitleRichText: field(name: "TitleRichText") { value }
        BlogImage: field(name: "Blog Image") { value }
        LastUpdated: field(name: "Last Updated") { value }
        PublishedDate:   field(name: "Published Date")   { value }
      }
    }
  }
`;

export const GET_BLOGS_BY_CATEGORY_AND_AUTHOR = gql`
  query GetBlogsByCategoryAndAuthor(
    $path: String!
    $pageSize: Int!
    $after: String
    $categoryId: String!
    $authorId: String!
  ) {
    search(
      first: $pageSize
      after: $after
      where: {
        AND: [
          { name: "_path", value: $path, operator: CONTAINS }
          {
            OR: [
              { name: "Categories", value: $categoryId, operator: CONTAINS }
              { name: "Tags",       value: $categoryId, operator: CONTAINS }
            ]
          }
          { name: "Author", value: $authorId, operator: CONTAINS }
        ]
      }
      orderBy: { name: "Published Date", direction: DESC }
    ) {
      total
      pageInfo { hasNext endCursor }
      results {
        id
        path
        TitleRichText: field(name: "TitleRichText") { value }
        BlogImage:     field(name: "Blog Image")     { value }
        LastUpdated:   field(name: "Last Updated")   { value }
        PublishedDate:   field(name: "Published Date")   { value }
      }
    }
  }
`;

export const GET_ALL_CATEGORIES = gql`
  query GetAllCategories($categoryPath: String!, $categoryTemplateId: String!) {
    categories: search(
      first: 500
      where: {
        AND: [
          { name: "_parent", value: $categoryPath, operator: EQ }
          { name: "_templates", value: $categoryTemplateId, operator: CONTAINS }
        ]
      }
      orderBy: { name: "_name", direction: ASC }
    ) {
      total
      results {
        id
        name
        path
      }
    }
  }
`;

